import React from "react";
import { createUuid } from '@app/utilities';
import OldInput from "./OldInput";
import { OldSwitch } from "./OldSwitch";

export class CallEncryption extends React.Component {
    /**
     * Global exception handling
     * @module ErrorHandling
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        const callEncryption = window.apm.serialized.appProperties.find((p) => {
            return p.type === 'callEncryption';
        }) ?? this.initDataModel();
        this.state = {
            callEncryptionobj: callEncryption,
            enabled: callEncryption.enabled,
            pubKeyNameProperty: callEncryption.pubKeyNameProperty,
            pubKeyUrlProperty: callEncryption.pubKeyUrlProperty
        }
        this.handleEnabled = this.handleEnabled.bind(this); 
    }

    initDataModel() {
        const callEncryption = {
            id: createUuid(),
            type: "callEncryption",
            config: "Full Call Encryption",
            enabled: false,
            pubKeyNameProperty: null,
            pubKeyUrlProperty: null,
            recordSensitiveUtterances: false,
            lastLocalChange: window.apm.timestamp
  
        };
        return callEncryption;
    }

    setConfig(key, value = false) {
        // everytime call encryp is off su should be on
        const callEncryption = this.state.callEncryptionobj;
        
        callEncryption[key] = value;
        this.setState({ callEncryptionobj: callEncryption, [key]: value });
        if (key === 'enabled' && value === false && callEncryption.recordSensitiveUtterances === true) {
            callEncryption.recordSensitiveUtterances = false;
            this.setState({ recordSensitiveUtterances: false });
        }
        callEncryption.lastLocalChange = window.apm.timestamp;

        this.setState({ callEncryptionobj: callEncryption });
        // updates app properties
        window.apm.setAppProperty(callEncryption);
        window.apm.setSerializedChanged();
    }

    handleEnabled(){
        const enabled = this.state.callEncryptionobj['enabled'];
        
        if(!enabled){
            document.dispatchEvent(new CustomEvent("ev-update-recordings-for-sensitive", {detail: {val: true}}));
        }
        
    }

    getConfig(key) {
        const callEncryption = this.state.callEncryptionobj;
        return callEncryption[key];
    }
    
    render() {

        return (
            <div className="row">
                <div className="col-md-3">
                    <br />
                    <OldSwitch 
                        context={this} 
                        valKey={"enabled"} 
                        label={"Full Call Encryption"} 
                        tooltip="Enables encryption for the entire call"
                        checked={this.state.enabled ? this.state.enabled : false} 
                        callback={this.handleEnabled}
                    />
                
                </div>
                <div className="col-md-4">
                    <OldInput 
                        label={"Public Key Name"}
                        tooltip={"Specify public key name used for encryption. Important! Only use App Property name, not its value."}
                        context={this} 
                        valKey={"pubKeyNameProperty"} 
                        value={this.state.pubKeyNameProperty} 
                        disabled={!this.state.enabled}
                        key={"pubKeyNameProperty"+this.state.enabled}
                        valRules= {this.state.enabled ? {"noEmpty": true} : {"noEmpty": false}}
                    />
                </div>
                <div className="col-md-4">
                    <OldInput 
                        label={"Public Key URL"}
                        tooltip={"Specify public key url used for encryption. Important! Only use App Property name, not its value."}
                        context={this} 
                        valKey={"pubKeyUrlProperty"} 
                        value={this.state.pubKeyUrlProperty}
                        disabled={!this.state.enabled} 
                        key={"pubKeyUrlProperty"+this.state.enabled}
                        valRules= {this.state.enabled ? {"noEmpty": true} : {"noEmpty": false}}
                    />
                </div>
                
                <div className="col-md-6">
                <OldSwitch 
                        context={this} 
                        valKey={"recordSensitiveUtterances"} 
                        label={" Record Sensitive Utterances"} 
                        tooltip="De-select Record Sensitive Utterances to prevent sensitive information like credit card numbers from being recorded."
                        disabled={this.state.enabled ? !this.state.enabled : true} 
                        checked={this.state.callEncryptionobj['recordSensitiveUtterances']} 
                    />
                </div>
                </div>
           
        );
    }
}